

import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  textClassName?: string;
}

export function Logo({ className = '', size = 'md', textClassName = '' }: LogoProps) {
  const sizes = {
    sm: { width: 80, height: 28 },
    md: { width: 100, height: 34 },
    lg: { width: 140, height: 48 },
  };

  const { width, height } = sizes[size];

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="0" y="0" width="40" height="40" rx="10" fill="var(--logo-background)" />
      <path
        d="M12 8C12 6.89543 12.8954 6 14 6H18C19.1046 6 20 6.89543 20 8V18C20 16.8954 20.8954 16 22 16H26C27.1046 16 28 16.8954 28 18V28C28 31.3137 25.3137 34 22 34H14C12.8954 34 12 33.1046 12 32V8Z"
        fill="var(--logo-ink)"
      />
      <rect x="14" y="10" width="4" height="20" rx="2" fill="var(--logo-accent)" />
      <rect x="20" y="20" width="4" height="10" rx="2" fill="var(--logo-accent)" />
      <text
        x="48"
        y="28"
        fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        fontSize="22"
        fontWeight="600"
        className={cn('fill-foreground', textClassName)}
      >
        backr
      </text>
    </svg>
  );
}

export function LogoIcon({ className = '', size = 32 }: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="0" y="0" width="40" height="40" rx="10" fill="var(--logo-background)" />
      <path
        d="M12 8C12 6.89543 12.8954 6 14 6H18C19.1046 6 20 6.89543 20 8V18C20 16.8954 20.8954 16 22 16H26C27.1046 16 28 16.8954 28 18V28C28 31.3137 25.3137 34 22 34H14C12.8954 34 12 33.1046 12 32V8Z"
        fill="var(--logo-ink)"
      />
      <rect x="14" y="10" width="4" height="20" rx="2" fill="var(--logo-accent)" />
      <rect x="20" y="20" width="4" height="10" rx="2" fill="var(--logo-accent)" />
    </svg>
  );
}
